/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

const { cos, min, max, PI } = Math;

const PIH = PI / 2;

export default class NoiseInit extends Phase {

	was_started = false;

	heat = null;
	face = null;

	constructor() {
		super(0);
	}

	getPreludeLength() {
		return null;
	}

	getPostludeLength() {
		return null;
	}

	run({ time, noise_opts }) {
		noise_opts.scale = [1, 0.9];
		noise_opts.displacement = 5;
		noise_opts.base_color[0] = 0;
		noise_opts.base_color[1] = 1;
		noise_opts.base_color[2] = 0;
		noise_opts.base_color[3] = 1;
		/* Initialise persistent data only when crossing start time (edge-triggered) */
		const started = time.relative >= 0;
		const crossed = time.relative === 0 || started && !this.was_started;
		this.was_started = started;

		const { data, brightness, thickness } = noise_opts;

		/* If crossed over start, zero buffers */
		if (crossed) {
			data.fill(0);
		}

		if (started) {
			const grow = min(max(time.relative / 2, 0), 1);
			for (let i = 0; i < data.length; i++) {
				const t = i / data.length;
				const fade = t > grow ? 0 : cos(PIH * t / grow);
				brightness[i] = (fade + 7) / 8;
				thickness[i] = 0.003 * fade;
			}
		}
	}
}
